export default "<p>footer-app works!</p>\n"